<template>
  <LoginWrapper>
    <div class="find-password-content">
      <div v-if="success">
        <!-- 成功提示 -->
        <div class="find-password-form">
          <div class="find-password-sended">
            <div class="find-password-tip">
              <Icon type="email-success" />
              <p>{{ $t('find_password_success_tip1') }}</p>
              <p class="find-password-email-tip">{{ form.nameOrEmail }}</p>
              <p class="find-password-tip2">* {{ $t('find_password_success_tip2') }}</p>
            </div>
          </div>
          <div class="find-password-btn">
            <a-button type="primary" @click="backLogin">
              {{ $t('find_password_back') }}
            </a-button>
          </div>
        </div>
      </div>
      <div v-else>
        <!-- 输入邮箱 -->
        <div class="find-password-title">
          {{ $t('find_password_title') }}

          <a-button
            type="link"
            size="small"
            style="position:absolute;right:-40px;top:10px;"
            icon="double-left"
            @click="backLogin"
          >
            {{ $t('com_btn_back') }}
          </a-button>
        </div>
        <div class="find-password-form">
          <!-- 第一步 -->
          <a-form-model :model="form" :rules="rules" ref="formElement">
            <a-form-model-item prop="nameOrEmail">
              <a-input
                v-model="form.nameOrEmail"
                size="large"
                style="min-width:200px"
                :placeholder="$t('find_password_email_placeholder')"
                allowClear
                ref="email"
                @input="input"
              >
                <Icon type="email" slot="prefix" />
              </a-input>
            </a-form-model-item>

            <div class="captcha">
              <div class="captcha-left">
                <a-form-model-item prop="validCode">
                  <a-input
                    v-model="form.validCode"
                    :placeholder="$t('find_password_captcha_placeholder')"
                    class="captcha-input"
                    ref="captcha"
                    size="large"
                    allowClear
                    @input="input"
                  >
                    <Icon type="verified" slot="prefix" />
                  </a-input>
                </a-form-model-item>
              </div>
              <div class="captcha-right">
                <div class="captcha-img" @click="changeCaptcha">
                  <img :src="`/api/unauth/vcode?_t=${captchaTime}`" />
                </div>
              </div>
            </div>

            <div class="find-password-btn">
              <a-button type="primary" @click="step1Sumbmit" :loading="submtting">
                {{ $t('com_btn_submit') }}
              </a-button>
            </div>
          </a-form-model>

          <!-- 错误描述 -->
          <div class="g-form-error" style="padding-top:25px;width:100%;justify-content: center;">
            <Icon type="error" v-if="formError" />
            <p>{{ formError }}</p>
          </div>
        </div>
      </div>
    </div>
  </LoginWrapper>
</template>
<script>
import LoginWrapper from '@/components/Layout/Login.vue';
import * as API from '@/api/findPassword';

export default {
  components: {
    LoginWrapper,
  },
  data() {
    return {
      captchaTime: new Date().getTime(),
      formError: '',
      form: {
        nameOrEmail: undefined,
        validCode: undefined,
      },
      rules: {
        nameOrEmail: [
          {
            required: true,
            message: this.$t('find_password_email_placeholder'),
            trigger: 'change',
          },
        ],
        validCode: [
          {
            required: true,
            message: this.$t('find_password_captcha_placeholder'),
            trigger: 'change',
          },
        ],
      },
      submtting: false,

      // 发送成功
      success: false,
    };
  },

  methods: {
    // 输入事件
    input() {
      this.error = '';
    },

    changeCaptcha() {
      this.captchaTime = new Date().getTime();
    },

    // 返回上一步
    backLogin() {
      this.$router.replace('/login');
    },

    // 第一步提交
    step1Sumbmit() {
      this.$refs.formElement.validate(valid => {
        if (valid) {
          this.submtting = true;
          this.formError = '';
          API.ValidateEmail(this.form)
            .then(res => {
              if (res.code === 0) {
                this.success = true;
                // const h = this.$createElement;
                // this.$success({
                //   title: 'Tips',
                //   centered: true,
                //   content: h('div', {}, [
                //     h('p', this.$t('find_password_success_tip1')),
                //     h('p', this.$t('find_password_success_tip2')),
                //   ]),

                //   onOk: () => {
                //     this.backLogin();
                //   },
                // });
              } else {
                if (res.code === 20015) {
                  this.$refs.captcha.focus();
                } else {
                  this.$refs.email.focus();
                }
                this.form.validCode = '';
                this.formError = res.message;
              }
            })
            .finally(() => {
              this.changeCaptcha();
              this.submtting = false;
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.find-password-content {
  background: #fff;
  width: 600px;
  border-radius: 10px;
  margin: 0 60px 80px 60px;

  // 标题
  .find-password-title {
    color: #18181a;
    font-size: 36px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-align: center;
    padding: 60px 0 50px 0;
    position: relative;

    span {
      font-size: 14px;
      color: #999;
      position: absolute;
      left: 10px;
    }
  }

  // 表单
  .find-password-form {
    padding: 25px;

    // 验证码
    .captcha {
      display: flex;
      .captcha-left {
        flex: 1;
      }

      .captcha-right {
        width: 120px;
        display: flex;
        justify-content: right;
        .captcha-img {
          width: 110px;
          background: #eee;
          height: 40px;
          border-radius: 4px;
          cursor: pointer;
          overflow: hidden;

          img {
            width: auto;
            height: 100%;
            max-width: 100%;
            max-height: 40px;
            cursor: pointer;
          }
        }
      }
    }

    .find-password-tip {
      color: #2196f3;
      text-align: center;

      p {
        color: #18181a;
        text-align: center;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;

        &.find-password-email-tip {
          font-weight: bold;
        }

        &.find-password-tip2 {
          color: #f5222d;
          text-align: center;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
      }

      svg {
        width: 120px;
        height: auto;
        font-size: 24px;
      }
    }

    ::v-deep .find-password-btn {
      padding-top: 20px;
      text-align: center;

      .ant-btn-primary {
        font-size: 18px;
        height: 50px;
        width: 100%;
        border-radius: 8px;
        box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.02);
      }
      button {
        width: 100%;
        cursor: pointer;
      }
    }
  }
}
</style>
